import { render } from "./submission-panel-supporter-info.vue?vue&type=template&id=c94135fa&scoped=true&ts=true"
import script from "./submission-panel-supporter-info.vue?vue&type=script&lang=ts"
export * from "./submission-panel-supporter-info.vue?vue&type=script&lang=ts"

import "./submission-panel-supporter-info.vue?vue&type=style&index=0&id=c94135fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94135fa"]])

export default __exports__